import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { Typography, useTheme } from '@mui/material';

/**
 * The component to show the user when they have successfully begun the password recovery process
 */
const Submitted = () => {
  const theme = useTheme();

  return (
    <>
      <EmailRoundedIcon sx={{ fontSize: '4em', marginY: '.25em' }} />
      <Typography
        variant="h1"
        fontSize="1.5em"
        fontWeight="bold"
        gutterBottom
        textAlign="center"
      >
        Check your email
      </Typography>
      <Typography
        color={theme.palette.text.secondary}
        textAlign="center"
        sx={{ maxWidth: '90%', marginBottom: '2em' }}
      >
        We&apos;ve sent you an email to reset your password.
      </Typography>
    </>
  );
};

export default Submitted;
